//import globalStylesUrl from 'url:../styles/global.css';
import oscarImg from 'url:../images/vol/oscar.jpeg';
import healthImg from 'url:../images/pexel/child-health.jpg';
import eduImg from 'url:../images/teach.jpg';
import hungerImg from 'url:../images/hunger-relief.png';
import disasterImg from 'url:../images/pexel/disaster.jpg';
import animalImg from 'url:../images/pexel/animal.jpg';

class CampaignSlider extends HTMLElement {
  constructor() {
    super();
    //this.attachShadow({ mode: 'open' });
  }
  // 1. Tell the browser which attributes to watch closely
  static get observedAttributes() {
    return ['exclude'];
  }

  // 2. Automatically trigger a re-render if the exclude attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'exclude' && oldValue !== newValue) {
      this.render();
    }
  }
  connectedCallback() {
    this.render();
    this.initCampScroll();
  }

  render() {
    const excludeCampaign = this.getAttribute('exclude');

    const campaigns = [
      {
        id: 'health',
        img: healthImg,
        title: 'health_care',
        pageUrl: '/health.html',
        altText: 'health_campaign',
        zeffyUrl: 'zeffy_health_link',
      },
      {
        id: 'edu',
        img: eduImg,
        title: 'edu_support',
        pageUrl: '/edu.html',
        altText: 'edu_campaign',
        zeffyUrl: 'zeffy_edu_link',
      },
      {
        id: 'hunger',
        img: hungerImg,
        title: 'hunger_relief',
        pageUrl: '/hunger.html',
        altText: 'hunger_campaign',
        zeffyUrl: 'zeffy_hunger_link',
      },
      {
        id: 'disasters',
        img: disasterImg,
        title: 'disaster_relief',
        pageUrl: '/disasters.html',
        altText: 'disaster_campaign',
        zeffyUrl: 'zeffy_disaster_link',
      },
      {
        id: 'animal',
        img: animalImg,
        title: 'animal_welfare',
        pageUrl: '/animals.html',
        altText: 'animal_campaign',
        zeffyUrl: 'zeffy_animal_link',
      },
    ];

    const cardsHtml = campaigns
      .filter((campaign) => campaign.id !== excludeCampaign)
      .map((campaign) => {
        return `
          <div class="campaign-card">
            <img
              src="${campaign.img}"
              alt="${campaign.altText}"
              data-i18n-attr='{"alt":"${campaign.altText}"}'
              class="campaign-image exam"
            />
            <div class="campaign-overlay">
              <h3 class="campaign-title" data-i18n="${campaign.title}">
                ${campaign.title}
              </h3>
              <button
                class="campaign-btn"
                zeffy-form-link="https://www.zeffy.com/es/embed/donation-form/donate-to-save-lives-191?modal=true"
                data-i18n-attr='{"zeffy-form-link":"${campaign.zeffyUrl}"}'
                data-i18n="support_campaign"
              >
                Support This Campaign
              </button>
              <a class="camp-link" href="${campaign.pageUrl}">
                <span><i class="fa-solid fa-circle-info"></i></span
                ><span data-i18n="learn_more"></span
              ></a>
            </div>
          </div>
        `;
      })
      .join('');

    this.innerHTML = `
    
    <div class="campaign-wrapper">
      <!-- Left Navigation Arrow -->
      <button
        id="navLeft"
        class="nav-arrow left"
        data-i18n-attr='{"aria-label":"scroll_left"}'
        aria-label="Scroll left"
      >
        &#10094;
      </button>

      <!-- Scroll Container -->
      <div class="campaign-container" id="campaignSlider">
        ${cardsHtml}
      </div>

      <!-- Right Navigation Arrow -->
      <button
        id="navRight"
        class="nav-arrow right"
        data-i18n-attr='{"aria-label":"scroll_right"}'
        aria-label="Scroll right"
      >
        &#10095;
      </button>
    </div>
        `;
  }

  initCampScroll() {
    const container = document.getElementById('campaignSlider');
    const leftArrow = document.getElementById('navLeft');
    const rightArrow = document.getElementById('navRight');
    if (!container || !leftArrow || !rightArrow) {
      return;
    }
    const scrollAmount = 320;

    // Attach click events safely inside JavaScript
    leftArrow.addEventListener('click', () => {
      container.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth',
      });
    });

    rightArrow.addEventListener('click', () => {
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth',
      });
    });
  }
}

customElements.define('campaign-slider', CampaignSlider);
// At the bottom of your custom element file:
// if (module.hot) {
//   module.hot.accept(() => {
//     // Force a page reload when this specific file updates to bypass the customElement registry freeze
//     window.location.reload();
//   });
// }
